<div class="modal-header">
  <h4 class="modal-title">{{ data.title }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="closeModal()"
  ></button>
</div>
<div class="modal-body">
  <p>{{ data.body }}</p>
  <form [formGroup]="welomeForm" (ngSubmit)="submit(welomeForm.value)">
    <!-- Email -->
    <div class="form-group col-md-12 pb-2">
      <label for="email" class="required">E-mail Address </label>
      <input
        formControlName="email"
        maxlength="250"
        type="email"
        class="form-control mt-2"
        id="email"
        placeholder="Enter Email Address"
        required
      />
    </div>
    <div class="modal-footer mt-3">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="closeModal()"
      >
        {{ data.cancelBtnText }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!welomeForm.valid"
      >
        Join
      </button>
    </div>
  </form>
</div>
